import { render, staticRenderFns } from "./app-modal.vue?vue&type=template&id=a8d3f0c0&scoped=true&"
import script from "./app-modal.vue?vue&type=script&lang=js&"
export * from "./app-modal.vue?vue&type=script&lang=js&"
import style0 from "./app-modal.vue?vue&type=style&index=0&id=a8d3f0c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d3f0c0",
  null
  
)

export default component.exports